<div class="modal-header">
  <h5 class="modal-title">{{ 'Meetday' | translate }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="facade.meetDayForm" novalidate>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'general'" (click)="activeTab = 'general'">
          {{ 'General' | translate }}
        </a>
      </li>
      @if (facade.showRoundsTab()) {
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'rounds'" (click)="activeTab = 'rounds'">
          {{ 'Rounds' | translate }}
        </a>
      </li>
      }
      @if (facade.entity().id) {
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'companies'" (click)="activeTab = 'companies'">
          {{ 'Companies' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'registrations'" (click)="activeTab = 'registrations'">
          {{ 'Registrations' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'emails'" (click)="activeTab = 'emails'">
          {{ 'Emails' | translate }}
        </a>
      </li>
      }
    </ul>

    <div class="tab-content pt-3">
      @if (activeTab === 'general') {
      <div class="tab-pane active">
        <app-meetday-tab-general />
      </div>
      }

      @if (activeTab === 'rounds' && facade.showRoundsTab()) {
      <div class="tab-pane active">
        <app-meetday-tab-rounds />
      </div>
      }

      @if (activeTab === 'companies' && facade.entity().id) {
      <div class="tab-pane active">
        <app-meetday-tab-companies />
      </div>
      }

      @if (activeTab === 'registrations' && facade.entity().id) {
      <div class="tab-pane active">
        <app-meetday-tab-registrations />
      </div>
      }

      @if (activeTab === 'emails' && facade.entity().id) {
      <div class="tab-pane active">
        <app-meetday-tab-emails />
      </div>
      }
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">{{ 'Cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" [disabled]="!facade.isFormValid()" (click)="save()">
    {{ 'Save' | translate }}
  </button>
</div>
